import React from 'react';
import { CTAButton } from './CTAButton';
export function EducationSection() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#f8fafc',
    borderColor: '#e2e8f0'
  }} data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-8" style={{
        color: '#0f172a'
      }} data-id="element-85">
          ¿Qué es una Landing Page?
        </h2>

        <div className="space-y-4 mb-12 text-lg" style={{
        color: '#64748b'
      }} data-id="element-86">
          <p data-id="element-87">Imagina que eres dueño de una clínica dental en tu ciudad.</p>
          <p data-id="element-88">Quieres que más personas vengan a hacerse una limpieza dental.</p>
          <p data-id="element-89">
            Necesitas una página web donde la gente aterrice, vea tu servicio y
            llame para agendar una cita.
          </p>
          <p style={{
          color: '#0f172a'
        }} data-id="element-90">
            <strong data-id="element-91">Eso es una landing page.</strong>
          </p>
          <p data-id="element-92">
            Una página web sencilla con un solo objetivo: hacer que alguien tome
            acción.
          </p>
          <p data-id="element-93">Nada más. Nada menos.</p>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-8" style={{
        color: '#0f172a'
      }} data-id="element-94">
          ¿Por qué los negocios pagan $200.000-$800.000 por una sola página?
        </h2>

        <div className="space-y-4 mb-8 text-lg" style={{
        color: '#64748b'
      }} data-id="element-95">
          <p data-id="element-96">Hay millones de pequeños negocios en Colombia.</p>
          <p data-id="element-97">
            Muchos de ellos tienen páginas web antiguas… o simplemente no tienen
            ninguna página donde los clientes puedan conocer sus servicios y
            contactarlos.
          </p>
          <p data-id="element-98">
            Cuando un negocio necesita una página web, normalmente tiene dos
            opciones:
          </p>
          <p data-id="element-99">
            Contratar a una agencia profesional que cobra{' '}
            <strong style={{
            color: '#0f172a'
          }} data-id="element-100">
              $3.000.000 o más
            </strong>{' '}
            y tarda de 3 a 8 semanas.
          </p>
          <p data-id="element-101">O intentar hacerlo ellos mismos, sin tiempo ni conocimiento.</p>
          <p data-id="element-102">
            Tú llegas con el{' '}
            <strong style={{
            color: '#f59e0b'
          }} data-id="element-103">
              Sistema LPM™
            </strong>{' '}
            y les dices:
          </p>
          <p className="text-xl font-bold pl-4 border-l-4" style={{
          color: '#0f172a',
          borderColor: '#f59e0b'
        }} data-id="element-104">
            "Te la construyo hoy mismo. Por $400.000."
          </p>
          <p data-id="element-105">El negocio se ahorra millones de pesos y semanas de espera.</p>
          <p data-id="element-106">
            Tú ganas{' '}
            <strong style={{
            color: '#0f172a'
          }} data-id="element-107">
              $400.000 en menos de 1 hora.
            </strong>
          </p>
          <p style={{
          color: '#0f172a'
        }} data-id="element-108">
            <strong data-id="element-109">Todos ganan.</strong>
          </p>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-8 mt-16" style={{
        color: '#0f172a'
      }} data-id="element-110">
          ¿Cómo lo haces sin saber nada?
        </h2>

        <p className="text-lg mb-6" style={{
        color: '#64748b'
      }} data-id="element-111">
          Con dos herramientas de Inteligencia Artificial que hacen el trabajo
          por ti:
        </p>

        <div className="overflow-x-auto mb-12" data-id="element-112">
          <table className="w-full border-collapse rounded-md overflow-hidden" data-id="element-113">
            <thead data-id="element-114">
              <tr style={{
              backgroundColor: '#0f172a'
            }} data-id="element-115">
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-116">
                  Herramienta
                </th>
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-117">
                  Qué hace
                </th>
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-118">
                  Tiempo
                </th>
              </tr>
            </thead>
            <tbody data-id="element-119">
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-120">
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-121">
                  🤖 ChatGPT
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-122">
                  Escribe todos los textos profesionales por ti
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-123">
                  30 segundos
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc',
              borderColor: '#e2e8f0'
            }} className="border-b" data-id="element-124">
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-125">
                  🎨 Magic Patterns
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-126">
                  Construye el diseño hermoso automáticamente
                </td>
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-127">
                  45 minutos
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-lg font-bold mb-12" style={{
        color: '#0f172a'
      }} data-id="element-128">
          La IA hace el trabajo. Tú cobras el dinero. Todo en menos de 1 hora.
        </p>

        <CTAButton text="QUIERO LA GUÍA PDF Y EMPEZAR HOY" subtitle="✅ Solo $49.999 · ✅ Descarga inmediata · ✅ Sin conocimientos previos" scrollTo="ebook-main" data-id="element-129" />
      </div>
    </section>;
}